import { z } from "zod";

export const envSchema = z.object({
  VITE_ON_PREMISE: z
    .enum(["true", "false"])
    .default("false")
    .transform((value) => value === "true"),
  VITE_PLATFORM_FLAVOR: z.string().optional(),
  // NOTE: PostHog product analytics (epic NSAI-2431). The key and the host
  // together are the on/off switch (NSAI-4623) — with either unset the SDK is
  // never loaded and nothing is sent.
  // That is the shipped default for local dev and for on-premise builds; see
  // `docs/observability/posthog-tracking-plan.md`.
  VITE_POSTHOG_KEY: z.string().optional(),
  VITE_POSTHOG_HOST: z.string().optional(),
  MODE: z.enum(["development", "production", "test"]).default("development"),
});

export type TEnvSchema = z.infer<typeof envSchema>;
